import { UserSubscriptionStatus } from '@/types/gql.generated';

/**
 * Mirrors the server's `isGrantingStatus` in
 * `server/src/services/stripe/plan.ts`. Deliberately duplicated rather than
 * inferred from a tier: entitlement and subscription state answer different
 * questions, and the client needs both. Keep the two in step — the server is
 * the authority, this is the copy.
 *
 * Note how narrow it is: a single failed payment moves a subscription to
 * PAST_DUE, which is *not* granting, so the plan is gone the moment dunning
 * starts. There is no grace period.
 */
export const isGrantingStatus = (
  status: UserSubscriptionStatus | null | undefined
): boolean =>
  status === UserSubscriptionStatus.Active ||
  status === UserSubscriptionStatus.Trialing;

/**
 * Statuses a Stripe subscription can never leave. The distinction that matters
 * downstream: a terminal subscription needs a fresh checkout, while everything
 * else non-granting (past due, unpaid, paused, incomplete) can still recover
 * through dunning or a payment fix — and must therefore never be sold a second
 * subscription, which would double-bill if the first one recovers.
 */
export const isTerminalStatus = (
  status: UserSubscriptionStatus | null | undefined
): boolean =>
  status === UserSubscriptionStatus.Canceled ||
  status === UserSubscriptionStatus.IncompleteExpired;
